import { FC } from 'react';

const LockIcon: FC = () => {
    return (
        <svg
            className="icon br-icon-lock"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.23602 18.182C3.37911 19.379 3.94396 20.4859 4.82928 21.3041C5.7146 22.1224 6.86246 22.5984 8.06702 22.647C10.6879 22.737 13.3111 22.7367 15.932 22.646C17.1365 22.5977 18.2843 22.1218 19.1697 21.3037C20.055 20.4856 20.6199 19.3789 20.763 18.182C20.8675 17.3155 20.9225 16.4437 20.928 15.571C20.928 14.69 20.861 13.819 20.763 12.961C20.6202 11.764 20.0555 10.6572 19.1704 9.83891C18.2852 9.02065 17.1375 8.54454 15.933 8.49597C14.622 8.44997 13.311 8.42597 12 8.42697C10.6887 8.42651 9.37751 8.44951 8.06702 8.49597C6.86242 8.54457 5.71457 9.02083 4.82939 9.83929C3.94422 10.6578 3.37966 11.7649 3.23702 12.962C3.13294 13.8278 3.07785 14.6989 3.07202 15.571C3.07202 16.454 3.13902 17.326 3.23602 18.182Z"
                fill="black"
                fillOpacity="0.12"
                stroke="currentColor"
                strokeWidth="2"
            />
            <path
                d="M17 8.43002V6.28502C16.9999 5.62841 16.8705 4.97825 16.6192 4.37164C16.3679 3.76504 15.9995 3.21388 15.5352 2.74963C14.5974 1.81205 13.3256 1.28539 11.9995 1.28552C10.6734 1.28566 9.4017 1.81257 8.46411 2.75034C7.52652 3.68812 6.99987 4.95994 7 6.28602V8.43002"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.9999 17.714C12.5683 17.714 13.1134 17.4882 13.5153 17.0863C13.9172 16.6844 14.1429 16.1393 14.1429 15.571C14.1429 15.0026 13.9172 14.4575 13.5153 14.0556C13.1134 13.6538 12.5683 13.428 11.9999 13.428C11.4316 13.428 10.8865 13.6538 10.4846 14.0556C10.0827 14.4575 9.85693 15.0026 9.85693 15.571C9.85693 16.1393 10.0827 16.6844 10.4846 17.0863C10.8865 17.4882 11.4316 17.714 11.9999 17.714Z"
                stroke="currentColor"
                strokeWidth="2"
            />
        </svg>
    );
};

export default LockIcon;
